import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isAuthenticated, getUser, logout } from "../lib/auth";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const authed = isAuthenticated();
  const user = getUser();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const linkCls = (path) =>
    `text-sm font-medium hover:text-purple-600 ${
      location.pathname === path ? "text-purple-600" : "text-gray-700"
    }`;

  const navLinks = (
    <>
      {authed ? (
        <>
          <Link to="/mes-radios" className={linkCls("/mes-radios")}>{t("nav.myRadios")}</Link>
          <Link to="/radios" className={linkCls("/radios")}>{t("nav.radios")}</Link>
        </>
      ) : (
        <>
          <Link to="/#features" className={linkCls("/#features")}>{t("nav.features")}</Link>
          <Link to="/#pricing" className={linkCls("/#pricing")}>{t("nav.pricing")}</Link>
          <Link to="/radios" className={linkCls("/radios")}>{t("nav.radios")}</Link>
        </>
      )}
    </>
  );

  return (
    <header className="fixed top-0 inset-x-0 w-full z-50 bg-white/90 backdrop-blur shadow-sm">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="text-xl font-extrabold text-purple-600 whitespace-nowrap tracking-tight">
          Waveo
        </Link>

        <nav className="hidden md:flex gap-5 text-sm">{navLinks}</nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />

          <div className="hidden md:flex items-center gap-3">
            {authed ? (
              <>
                <Link to="/creer-radio/step1" className="text-sm font-medium bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded-md">
                  ＋ {t("nav.create")}
                </Link>
                <Link to="/profile" className="text-sm font-medium text-gray-700 hover:text-purple-600">
                  {user?.first_name ? `👤 ${user.first_name}` : t("nav.profile")}
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-2 rounded-md"
                >
                  {t("nav.logout")}
                </button>
              </>
            ) : (
              <>
                <Link to="/signin" className="text-sm font-medium text-gray-700 hover:text-purple-600">
                  {t("nav.signin")}
                </Link>
                <Link
                  to="/signup"
                  className="bg-purple-600 hover:bg-purple-700 text-white text-sm px-4 py-2 rounded-md"
                >
                  {t("nav.signup")}
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu toggle */}
          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
            aria-expanded={open}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-gray-100 bg-white px-6 py-4">
          <nav className="flex flex-col gap-3">{navLinks}</nav>
          <div className="mt-4 flex flex-col gap-2">
            {authed ? (
              <>
                <Link to="/creer-radio/step1" className="text-sm font-medium bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded-md text-center">
                  ＋ {t("nav.create")}
                </Link>
                <Link to="/profile" className="text-sm font-medium text-gray-700 hover:text-purple-600">
                  {user?.first_name ? `👤 ${user.first_name}` : t("nav.profile")}
                </Link>
                <button onClick={handleLogout} className="text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-2 rounded-md">
                  {t("nav.logout")}
                </button>
              </>
            ) : (
              <>
                <Link to="/signin" className="text-sm font-medium text-gray-700 hover:text-purple-600">
                  {t("nav.signin")}
                </Link>
                <Link to="/signup" className="bg-purple-600 hover:bg-purple-700 text-white text-sm px-4 py-2 rounded-md text-center">
                  {t("nav.signup")}
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
